import { useEffect, useState } from "react";
import type { Editor } from "./canvas";
export function setZoomPercent(editor: Editor, percent: number) {
  if (!Number.isFinite(percent)) return;
  const z = Math.max(0.1, Math.min(8, percent / 100)),
    center = editor.getViewportPageBounds().center,
    view = editor.getViewportScreenBounds();
  editor.setCamera({
    x: view.w / (2 * z) - center.x,
    y: view.h / (2 * z) - center.y,
    z,
  });
}
export function ZoomControl({
  editor,
  zoom,
}: {
  editor: Editor;
  zoom: number;
}) {
  const [value, setValue] = useState(String(Math.round(zoom * 100)));
  useEffect(() => setValue(String(Math.round(zoom * 100))), [zoom]);
  return (
    <form
      className="zoom-input"
      onSubmit={(e) => {
        e.preventDefault();
        setZoomPercent(editor, Number(value));
        editor.focus();
      }}
    >
      <input
        aria-label="Zoom percentage"
        type="number"
        min="10"
        max="800"
        step="10"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={() => {
          if (value !== "") setZoomPercent(editor, Number(value));
        }}
      />
      <span>%</span>
    </form>
  );
}
